import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CreditCard } from 'lucide-react';

const FeesPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold text-slate-800 mb-8">Fees</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="text-lg text-gray-700 mb-6">
            Our fee structure is designed to be transparent and accessible. We offer competitive rates 
            for all our services and provide various payment options to suit your needs.
          </p>

          <div className="bg-blue-50 border-l-4 border-blue-500 p-6 mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Service Fees</h2>
            <div className="space-y-4">
              <div className="flex justify-between items-center py-2 border-b border-gray-200">
                <span className="font-medium">Individual Therapy Session (50 minutes)</span>
                <span className="text-blue-600 font-semibold">£80 - £120</span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-200">
                <span className="font-medium">Couples Therapy Session (50 minutes)</span>
                <span className="text-blue-600 font-semibold">£100 - £150</span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-200">
                <span className="font-medium">Assessment/Diagnostics</span>
                <span className="text-blue-600 font-semibold">£150 - £300</span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-gray-200">
                <span className="font-medium">Group Therapy Session</span>
                <span className="text-blue-600 font-semibold">£40 - £60</span>
              </div>
            </div>
          </div>

          <h2 className="text-2xl font-semibold text-slate-800 mb-4">Payment Information</h2>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>Payment is required at the time of booking or before the session</li>
            <li>We accept all major credit cards, debit cards, and PayPal</li>
            <li>Cancellation policy: 24 hours notice required for full refund</li>
            <li>Reduced rates may be available for students and low-income individuals</li>
          </ul>

          <div className="mt-8 p-4 bg-gray-50 rounded-lg">
            <p className="text-sm text-gray-600 mb-4">
              For specific pricing information or to discuss payment plans, please contact us directly.
            </p>
          </div>

          {/* Payment System Link */}
          <div className="mt-8 text-center">
            <button
              onClick={() => navigate('/book-now')}
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold transition-colors duration-200 inline-flex items-center gap-2"
            >
              <CreditCard className="w-5 h-5" />
              Book & Pay Now
            </button>
            <p className="text-sm text-gray-600 mt-4">
              Secure online payment available through our central booking system
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeesPage;